import { render, staticRenderFns } from "./CadastroPacCamposObrig.vue?vue&type=template&id=18c0f3fe&"
import script from "./CadastroPacCamposObrig.vue?vue&type=script&lang=js&"
export * from "./CadastroPacCamposObrig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports